var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resend-code",on:{"click":_vm.resendCode}},[(_vm.errorMessage)?_c('span',{class:{
      'resend-code_active': _vm.error === '422012',
      'resend-code_expired': _vm.error === '422013',
    }},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")]):_vm._e(),(_vm.error !== '422012')?_c('span',{staticClass:"resend-code_underline",class:{
      'resend-code_active': !_vm.showTimer,
    }},[_vm._v(" "+_vm._s(_vm.$t('form.buttons.resendVerificationCode'))+" ")]):_vm._e(),(_vm.showTimer)?[_vm._v("("+_vm._s(_vm.timer)+")")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }